package com.merkost.handpass.admin.api

import com.varabyte.kobweb.core.AppGlobals
import io.ktor.client.*
import io.ktor.client.engine.js.*
import io.ktor.client.plugins.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.client.request.*
import io.ktor.client.statement.*
import io.ktor.http.HttpStatusCode
import io.ktor.serialization.kotlinx.json.*
import kotlinx.serialization.json.Json

private val API_BASE_URL: String = AppGlobals.getValue("admin.apiBaseUrl")

object AdminApiClient {
    var accessToken: String? = null
    var onUnauthorized: (() -> Unit)? = null

    val httpClient = HttpClient(Js) {
        expectSuccess = false
        install(HttpTimeout) {
            requestTimeoutMillis = 20_000
        }
        install(ContentNegotiation) {
            json(Json {
                ignoreUnknownKeys = true
                isLenient = true
            })
        }
        HttpResponseValidator {
            validateResponse { response ->
                if (response.status == HttpStatusCode.Unauthorized) {
                    onUnauthorized?.invoke()
                }
            }
        }
        defaultRequest {
            url(API_BASE_URL)
            accessToken?.let { token ->
                header("Authorization", "Bearer $token")
            }
        }
    }
}
